import { RouteComponentProps } from 'react-router-dom';
import qs from 'query-string';
import { AppDispatch } from 'src/store';
import { IQueryParams } from 'src/types';
import { convertFilterToArray } from 'src/utils/convertFilter';
import { removeEmpty } from 'src/utils/removeEmpty';
import { createAction } from '@reduxjs/toolkit';

import { fetchPayoutOrderByIdRequest, fetchPayoutOrderHistoryRequest, fetchPayoutOrdersRequest } from './requestHandlers';
import { IPayoutHistoryItemData, IPayoutOrderListData } from './types';

const defaultParams = {
  page: '0',
  size: '10',
  sort: 'orderCreatedAt,desc',
};

export const loadPayoutOrderStart = createAction('payout_orders/load/start');
export const loadPayoutOrderListSuccess = createAction<IPayoutOrderListData>('payout_orders/load/success');
export const loadPayoutOrderItemStart = createAction('payout_orders/item/load/start');
export const loadPayoutOrderItemSuccess = createAction<IPayoutHistoryItemData>('payout_orders/item/load/success');
export const resetPayoutOrderItem = createAction('payout_orders/item/reset');

export const loadPayoutOrdersRequest = (
  history: RouteComponentProps['history'],
  params: IQueryParams = {},
  isInitialLoading?: boolean,
  type?: string,
) => {
  return async (dispatch: AppDispatch): Promise<void> => {
    if (isInitialLoading) {
      dispatch(loadPayoutOrderStart());
    }
    const initialParams = qs.parse(history.location.search);
    const mergedParams = type === 'reset' ? defaultParams : removeEmpty({ ...defaultParams, ...initialParams, ...params });

    mergedParams.merchantIds = convertFilterToArray(mergedParams.merchantIds);
    mergedParams.merchantAccountIds = convertFilterToArray(mergedParams.merchantAccountIds);
    mergedParams.systemGroupFormIds = convertFilterToArray(mergedParams.systemGroupFormIds);
    mergedParams.statuses = convertFilterToArray(mergedParams.statuses);
    mergedParams.providerNames = convertFilterToArray(mergedParams.providerNames);

    const data = await fetchPayoutOrdersRequest(mergedParams);
    if (data) {
      dispatch(loadPayoutOrderListSuccess(data));
      history.replace({
        search: qs.stringify(mergedParams, { skipNull: true }),
      });
    }
  };
};

export const loadPayoutOrderItemRequest = ({ orderId, orderIdentity }: { orderId: string; orderIdentity: string }) => {
  return async (dispatch: AppDispatch): Promise<void> => {
    dispatch(loadPayoutOrderItemStart());

    const general = await fetchPayoutOrderByIdRequest(orderId);
    const history = await fetchPayoutOrderHistoryRequest({ orderIdentity });

    if (!general || !history) {
      return;
    }

    dispatch(
      loadPayoutOrderItemSuccess({ general, history: history.payoutLogHistory, resendCallbackStatus: history.resendCallbackStatus }),
    );
  };
};
